import React from 'react'
import { ISafetyTeamRecord } from '../../shared/types'
import { utils, writeFileXLSX } from 'xlsx'

import styles from './ExportButton.module.scss'

interface IExportButtonProps {
  activeRecords: ISafetyTeamRecord[]
  archivedRecords: ISafetyTeamRecord[]
}

const buildRows = (records: ISafetyTeamRecord[], status: 'Active' | 'Closed') => {
  return records.map((record) => ({
    Status: status,
    Driver: record.driver?.displayName || record.driver?.name || '',
    'Drivers License Number': record.driversLicenseNumber,
    'Driver Type': record.driverType,
    'Test Date': record.testDate,
    'Assigned Date': record.assignedDate,
    'Archived Date': record.archivedDate,
    Documents: (record.documents || []).map((doc) => doc.name).join(', '),
  }))
}

const ExportButton = ({ activeRecords, archivedRecords }: IExportButtonProps) => {
  const hasData = activeRecords.length > 0 || archivedRecords.length > 0

  const handleExport = () => {
    if (!hasData) return

    try {
      const workbook = utils.book_new()

      const activeRows = buildRows(activeRecords, 'Active')
      const archivedRows = buildRows(archivedRecords, 'Closed')

      if (activeRows.length > 0) {
        const activeSheet = utils.json_to_sheet(activeRows)
        utils.book_append_sheet(workbook, activeSheet, 'Active')
      }

      if (archivedRows.length > 0) {
        const archivedSheet = utils.json_to_sheet(archivedRows)
        utils.book_append_sheet(workbook, archivedSheet, 'Closed')
      }

      writeFileXLSX(workbook, 'SafetyTeam.xlsx')
    } catch (error) {
      console.error('Failed to export Safety Team data:', error)
    }
  }

  return (
    <button
      type="button"
      onClick={handleExport}
      disabled={!hasData}
      className={styles.exportButton}
    >
      Export XLSX
    </button>
  )
}

export default ExportButton
